import { VatDto } from 'src/app/shared/interfaces';
import { WorkflowInstanceDTO } from './workflow-instance';

export class Bacs {
  id: number;
  name: string;
  description: string;
  type: 'Entrant' | 'Traitement';
  nePasUtilise: boolean;
  transfertManuel: boolean;
  virtuel: boolean;
  createdAppUserId: string;
  createdExternalUserId: string;
  createdDate: string;
  updatedExternalUserId: string;
  updatedAppUserId: string;
  updatedDate: string;
  rightUserIds: number[];
  rightServiceIds: number[];
  rightGroupIds: number[];
  externalId?: string;
  typeDisplay?: string;
  workFlow?: WorkflowInstanceDTO;

  constructor(data?: BacsDTO | Partial<Bacs> | VatDto) {
    Object.assign(this, data);
    this.typeDisplay = this.type === 'Entrant' ? 'Entrée' : this.type;
  }
}

export interface BacsDTO {
  id: number;
  parentId: number;
  name: string;
  description: string;
  type: string;
  nePasUtilise: boolean;
  transfertManuel: boolean;
  virtuel: boolean;
}
